import styled from "styled-components"

export const TetrisPortfolioBox = styled.div`
width: 100%;
height: 100%;
margin: auto;
`;

export const TetrisFrame = styled.iframe`
  width: 100%;
  /* max-width: 100%; */
  /* max-height: calc(100vh - 64px); */
  /* height: calc(667px - calc(50vw - 250px)); */
  height: 100%;
  border: 0;
  overflow: hidden;
  border: none;
`;